export const toolbarButtons: string[] = [
  "fullscreen",
  "bold",
  "italic",
  "underline",
  "|",
  "fontSize",
  "color",
  "|",
  "paragraphFormat",
  "align",
  "outdent",
  "indent",
  "quote",
  "-",
  "insertLink",
  "insertImage",
  "|",
  "fontAwesome",
  "insertHR",
  "selectAll",
  "clearFormatting",
  "|",
  "html"
];
